import React, { forwardRef } from 'react';

const IcStatusConnected = forwardRef((properties, ref) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    fill: "none",
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    ...properties,
    ref
  },
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      height: "6",
      rx: "3",
      stroke: "var(--color-status-device-connected)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      width: "12",
      x: "2",
      y: "5"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6 8H10",
      stroke: "var(--color-status-device-connected)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    }
  )
));

export { IcStatusConnected };
//# sourceMappingURL=ic-status-connected.js.map
